import api from "../../utils/axios-util";
import {autodialnumberpopstate } from "../Calls/CallAction"
import Middleware from "../../utils/api-middleware"
export const Subdispo = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            await api
                .get(`/subdisposition?dispo_id=${payload}`)
                .then((response) => {
                    let res= Middleware("subdispo","fetch",response)
                    resolve(res);
                })
                .catch((err) => {
                     let res= Middleware("subdispo","fetch",err.response.data,"catch")
                    reject(res);
                });
        });
    }
};

export const GetSubdispo = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
           
            await api
                .get(`/subdisposition?skip=0&take=10&subdispo_id=${payload}`)
                .then((response) => {
                    let res= Middleware("subdispo","fetch",response)
                    resolve(res);
                   
                   
                })
                .catch((err) => {
                    let res= Middleware("subdispo","fetch",err.response.data,"catch")
                    reject(res);
                });
        });
    }

};
export const Getdispo = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
           
            await api
                .get(`/disposition?skip=0&take=10&dispo_id=${payload}`)
                .then((response) => {
                    let res= Middleware("dispo","fetch",response)
                    resolve(res);
                   
                   
                })
                .catch((err) => {
                    let res= Middleware("dispo","fetch",err.response.data,"catch")
                    reject(res);
                });
        });
    }

};

export const CallActivity = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
            let state = getState()
            await api
                .post(`/asterdialer/call/activity`,payload)
                .then((response) => {
                    let res= Middleware("callactivity","create",response)
                    
                   if (res.statusCode == 201){
                    if(state.call.autodialstatus == true && payload.callType == 'preview'){
                        dispatch(autodialnumberpopstate())
                    }
                   }
                   
                   resolve(res);
                })
                .catch((err) => {
                    let res= Middleware("callactivity","create",err.response.data,"catch")
                    reject(res);
                });
        });
    }

};

export const Getannouncement = (payload) => {
    return (dispatch, getState) => {
        return new Promise(async (resolve, reject) => {
           
            await api
                .get(`/get/announcement?campaign=${localStorage.getItem("selectedCampaign")}&status=Active`)
                .then((response) => {
                    let res= Middleware("announcement","fetch",response)
                    resolve(res);
                   
                   
                })
                .catch((err) => {
                    let res= Middleware("announcement","fetch",err.response.data,"catch")
                    reject(res);
                });
        });
    }
 
};
